/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentFirmwareFamily } from './equipment-firmware-family';
import { EquipmentModes } from './equipment-modes';
import { EquipmentByIdLocationResponse } from './equipment-by-id-location-response';
import { DeviceFaultResponse } from './device-fault-response';
import { EquipmentStatuses } from './equipment-statuses';
import { EquipmentSubModelResponse } from './equipment-sub-model-response';


export interface EquipmentByIdResponse { 
    id: string;
    serialNumber?: string | null;
    ipAddress: string;
    macAddress: string;
    currentHashrate: number;
    hashrateUnitId: number;
    uptime?: number | null;
    collectedAt?: string | null;
    telemetryFresh?: boolean;
    boardTemperature?: number;
    chipTemperature?: number;
    fanSpeeds?: Array<number> | null;
    model: string;
    subModel?: EquipmentSubModelResponse;
    nominalHashrate?: number;
    status: EquipmentStatuses;
    mode?: EquipmentModes;
    availableModes?: Array<EquipmentModes> | null;
    unavailableModes?: Array<EquipmentModes> | null;
    syntheticSleepActive?: boolean;
    firmwareId?: string | null;
    firmwareName?: string | null;
    rawFirmware?: string | null;
    firmwareFamily: EquipmentFirmwareFamily;
    location?: EquipmentByIdLocationResponse;
    faults?: Array<DeviceFaultResponse> | null;
    faultsCollectedAt?: string | null;
}



